import type { Movie, CategoryMeta } from "@/types/content";

export const categories: CategoryMeta[] = [
  {
    key: "tv",
    title: "电视剧",
    subtitle: "最新电视剧",
    description: "浏览蜜月TV精选电视剧，了解最新剧集更新与口碑佳作。",
  },
  {
    key: "movie",
    title: "电影",
    subtitle: "精选电影",
    description: "蜜月TV电影专区，汇聚院线热映与口碑经典，助你快速选片。",
  },
  {
    key: "anime",
    title: "动漫",
    subtitle: "热门动漫",
    description: "动漫爱好者聚集地，追更新番与经典动画，尽在蜜月TV。",
  },
];

export const movies: Movie[] = [
  {
    id: "tv-long-night-river",
    title: "长夜星河",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "剧情"],
    director: "沈星野",
    cast: ["周砚", "林清欢", "许知行"],
    rating: 9.1,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20drama%20poster%2C%20lone%20figure%20standing%20under%20a%20vast%20starry%20night%20sky%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20atmospheric%20lighting%2C%20minimal%20composition%2C%20premium%20film%20poster%20art&width=600&height=900&seq=miyue-tv-poster-01&orientation=portrait",
    synopsis:
      "一档深夜电台节目意外连接到三十年后的频率，主持人周砚在星河的指引下，一步步揭开一段被时间掩埋的真相。剧集以细腻的情感与冷峻的科幻设定交织，探讨记忆、孤独与重逢。",
    tags: ["独播", "高分", "科幻悬疑"],
  },
  {
    id: "tv-south-of-city",
    title: "城市之南",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "情感", "家庭"],
    director: "程浅",
    cast: ["苏晚", "顾远航", "白露"],
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20urban%20drama%20poster%2C%20young%20woman%20silhouette%20in%20a%20city%20street%20at%20golden%20hour%2C%20soft%20orange%20sunset%20light%2C%20cosy%20melancholic%20mood%2C%20clean%20minimal%20layout%2C%20editorial%20photography&width=600&height=900&seq=miyue-tv-poster-02&orientation=portrait",
    synopsis:
      "三个从小一起长大的朋友，在城市最南端的老街区重聚。面对拆迁、创业与情感的选择，他们在烟火气中重新找回生活的方向。",
    tags: ["治愈", "都市生活"],
  },
  {
    id: "tv-silent-testimony",
    title: "沉默的证词",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["刑侦", "悬疑", "犯罪"],
    director: "陆沉",
    cast: ["韩墨", "江屿", "温以宁"],
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20poster%2C%20detective%20walking%20through%20rainy%20neon%20alley%2C%20moody%20dark%20teal%20and%20amber%20lighting%2C%20tense%20cinematic%20atmosphere%2C%20minimal%20gritty%20style&width=600&height=900&seq=miyue-tv-poster-03&orientation=portrait",
    synopsis:
      "一名法医在尘封多年的旧案中发现疑点，与固执的刑警搭档联手翻查真相。每一份沉默的证词背后，都藏着一段不为人知的故事。",
    tags: ["悬疑", "烧脑", "口碑"],
  },
  {
    id: "tv-blossom-season",
    title: "花开时节",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["家庭", "剧情", "年代"],
    director: "何书",
    cast: ["秦岚", "老周", "小满"],
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20family%20drama%20poster%2C%20rural%20courtyard%20blooming%20spring%20flowers%2C%20warm%20soft%20sunlight%2C%20gentle%20golden%20palette%2C%20serene%20sentimental%20mood%2C%20elegant%20minimal%20composition&width=600&height=900&seq=miyue-tv-poster-04&orientation=portrait",
    synopsis:
      "返乡青年带着城市里的新想法回到南方小镇，与守着一片花田的奶奶一起，让老院子重新热闹起来。",
    tags: ["温情", "合家欢"],
  },
  {
    id: "movie-drifter-dawn",
    title: "流浪者黎明",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    director: "沈星野",
    cast: ["周砚", "米娜", "老K"],
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20adventure%20movie%20poster%2C%20lone%20traveler%20on%20an%20alien%20desert%20planet%20at%20dawn%2C%20orange%20sky%20and%20distant%20megastructure%2C%20cinematic%20grand%20scale%2C%20minimal%20bold%20design&width=600&height=900&seq=miyue-tv-poster-05&orientation=portrait",
    synopsis:
      "地球资源枯竭后，一支流浪舰队踏上寻找新家园的旅程。当黎明在陌生星球升起，人类必须在希望与牺牲之间做出选择。",
    tags: ["院线", "视效", "硬核科幻"],
  },
  {
    id: "movie-city-in-wind",
    title: "风中有座城",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "文艺", "剧情"],
    director: "程浅",
    cast: ["苏晚", "宋以朗"],
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20art%20house%20movie%20poster%2C%20couple%20cycling%20along%20a%20coastal%20road%20at%20sunset%2C%20soft%20peach%20and%20warm%20orange%20tones%2C%20dreamy%20breeze%20mood%2C%20airy%20minimal%20composition&width=600&height=900&seq=miyue-tv-poster-06&orientation=portrait",
    synopsis:
      "一间开在海边的旧书店，一段被风吹散的往事。两个各怀心事的年轻人，在一整个夏天里，慢慢学会告别与重逢。",
    tags: ["治愈", "爱情", "口碑"],
  },
  {
    id: "movie-hunter-action",
    title: "猎影行动",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["动作", "犯罪", "警匪"],
    director: "高振",
    cast: ["雷震", "陈淑仪", "阿鬼"],
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=action%20thriller%20movie%20poster%2C%20silhouette%20of%20a%20man%20running%20through%20a%20neon%20lit%20harbor%20at%20night%2C%20high%20contrast%20amber%20and%20dark%20blue%2C%20dynamic%20tense%20mood%2C%20bold%20minimal%20style&width=600&height=900&seq=miyue-tv-poster-07&orientation=portrait",
    synopsis:
      "一名卧底警探在收网前夜身份暴露，整座城市的黑与白在十二小时内彻底翻转。一场关于忠诚与信念的硬核追击就此展开。",
    tags: ["动作", "高燃", "港片"],
  },
  {
    id: "movie-mountain-sea",
    title: "山海秘语",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["奇幻", "冒险", "古装"],
    director: "陆沉",
    cast: ["江屿", "温以宁", "云开"],
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%2C%20ancient%20mystic%20mountains%20and%20misty%20valleys%2C%20ethereal%20golden%20light%20rays%2C%20mythical%20eastern%20aesthetic%2C%20epic%20minimal%20composition&width=600&height=900&seq=miyue-tv-poster-08&orientation=portrait",
    synopsis:
      "古籍记载的山海异境真实存在。少年为寻回失踪的兄长，踏入云雾深处，揭开了一段被世代守护的古老秘密。",
    tags: ["奇幻", "东方美学"],
  },
  {
    id: "anime-star-track",
    title: "星轨之下",
    type: "anime",
    year: 2024,
    region: "日本",
    genres: ["科幻", "机战", "热血"],
    director: "一之濑川",
    cast: ["佐野绫", "高桥凉"],
    rating: 9.0,
    cover:
      "https://readdy.ai/api/search-image?query=anime%20mecha%20poster%2C%20young%20pilot%20before%20a%20giant%20robot%20under%20a%20star%20filled%20sky%2C%20vivid%20orange%20and%20blue%20accents%2C%20energetic%20cel%20shaded%20style%2C%20dynamic%20composition&width=600&height=900&seq=miyue-tv-poster-09&orientation=portrait",
    synopsis:
      "在星轨交错的战场上，少年驾驶员与他的机体一同成长。友情、信念与守护的代价，在每一次出击中被重新定义。",
    tags: ["新番", "机战", "高分"],
  },
  {
    id: "anime-dream-park",
    title: "幻梦乐园",
    type: "anime",
    year: 2023,
    region: "日本",
    genres: ["奇幻", "治愈", "冒险"],
    director: "宫本樱",
    cast: ["小林雫", "花泽凛"],
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=whimsical%20anime%20poster%2C%20girl%20with%20a%20lantern%20entering%20a%20glowing%20dreamlike%20amusement%20park%2C%20pastel%20warm%20palette%20with%20golden%20glow%2C%20soft%20magical%20atmosphere%2C%20charming%20hand%20drawn%20style&width=600&height=900&seq=miyue-tv-poster-10&orientation=portrait",
    synopsis:
      "每当夜幕降临，一座只对迷路之人开放的乐园便会浮现。少女在无尽的梦境中，寻找着回到现实的那扇门。",
    tags: ["治愈", "奇幻", "口碑"],
  },
  {
    id: "anime-sword-far",
    title: "剑与远方",
    type: "anime",
    year: 2024,
    region: "中国大陆",
    genres: ["热血", "武侠", "冒险"],
    director: "白墨",
    cast: ["风无痕", "苏小满"],
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20anime%20poster%2C%20swordsman%20standing%20on%20a%20cliff%20at%20dusk%2C%20flowing%20robe%20in%20the%20wind%2C%20warm%20amber%20sky%20with%20distant%20mountains%2C%20ink%20painting%20inspired%20cinematic%20style&width=600&height=900&seq=miyue-tv-poster-11&orientation=portrait",
    synopsis:
      "少年剑客为寻一把传说中的断剑，踏遍江湖山河。一路上遇见的人与事，让他在剑锋之外，读懂了侠义的真正含义。",
    tags: ["国漫", "热血", "武侠"],
  },
  {
    id: "anime-sweet-town",
    title: "甜梦小镇",
    type: "anime",
    year: 2022,
    region: "日本",
    genres: ["日常", "治愈", "美食"],
    director: "宫本樱",
    cast: ["小林雫"],
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20slice%20of%20life%20anime%20poster%2C%20small%20sunlit%20town%20bakery%20with%20warm%20bread%20and%20flowers%2C%20gentle%20honey%20and%20cream%20palette%2C%20soft%20peaceful%20mood%2C%20hand%20drawn%20illustration&width=600&height=900&seq=miyue-tv-poster-12&orientation=portrait",
    synopsis:
      "小镇上有一家只在清晨营业的甜品店。老板娘用一块蛋糕、一杯热茶，安慰着每一个带着心事路过的客人。",
    tags: ["日常", "治愈", "轻松"],
  },
  {
    id: "tv-echo-of-tide",
    title: "潮汐回声",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "剧情", "年代"],
    director: "程浅",
    cast: ["苏晚", "韩墨"],
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20poster%2C%20lighthouse%20by%20the%20sea%20at%20dusk%2C%20crashing%20waves%20and%20warm%20amber%20sky%2C%20moody%20atmospheric%20tone%2C%20minimal%20elegant%20composition&width=600&height=900&seq=miyue-tv-poster-13&orientation=portrait",
    synopsis:
      "海边小镇每年都会出现一次怪异的退潮，露出海底的旧钟楼。返乡的青年记者循着潮汐的规律，打捞起一段被海风掩埋的往事。",
    tags: ["悬疑", "年代", "口碑"],
  },
  {
    id: "tv-winter-signal",
    title: "冬日信号",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "爱情", "剧情"],
    director: "陆沉",
    cast: ["林清欢", "顾远航"],
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=snowy%20romantic%20sci-fi%20poster%2C%20person%20holding%20a%20glowing%20device%20in%20falling%20snow%2C%20cool%20blue%20tones%20with%20warm%20orange%20glow%2C%20quiet%20tender%20atmosphere%2C%20cinematic%20minimal%20style&width=600&height=900&seq=miyue-tv-poster-14&orientation=portrait",
    synopsis:
      "一场持续四十天的暴雪里，城市接收到了来自北方的神秘信号。气象学家与失联多年的旧友，在寒冬中重新靠近。",
    tags: ["科幻", "冬日", "新剧"],
  },
  {
    id: "movie-last-letter",
    title: "最后一封信",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭", "文艺"],
    director: "何书",
    cast: ["秦岚", "宋以朗"],
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20family%20drama%20poster%2C%20hands%20holding%20an%20old%20letter%20by%20a%20window%20with%20soft%20afternoon%20light%2C%20warm%20sepia%20and%20cream%20tones%2C%20tender%20nostalgic%20mood%2C%20minimal%20elegant%20design&width=600&height=900&seq=miyue-tv-poster-15&orientation=portrait",
    synopsis:
      "邮局即将关闭，一封积压了三十年的信件被重新发现。送信的老邮差踏上寻找收信人的路，也找回了自己错过的时光。",
    tags: ["催泪", "亲情", "口碑"],
  },
  {
    id: "movie-sky-border",
    title: "天际线",
    type: "movie",
    year: 2022,
    region: "中国香港",
    genres: ["科幻", "动作", "灾难"],
    director: "高振",
    cast: ["雷震", "陈淑仪"],
    rating: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=disaster%20sci-fi%20movie%20poster%2C%20city%20skyline%20with%20glowing%20energy%20barrier%20and%20storm%20clouds%2C%20dramatic%20orange%20and%20dark%20blue%20contrast%2C%20epic%20tense%20mood%2C%20bold%20minimal%20style&width=600&height=900&seq=miyue-tv-poster-16&orientation=portrait",
    synopsis:
      "一道突如其来的能量屏障将整座城市与外界隔绝。工程师与救援队必须在资源耗尽前，找到屏障的源头。",
    tags: ["灾难", "视效", "紧张"],
  },
  {
    id: "anime-cloud-riders",
    title: "云上骑士",
    type: "anime",
    year: 2023,
    region: "日本",
    genres: ["冒险", "奇幻", "热血"],
    director: "一之濑川",
    cast: ["高桥凉", "花泽凛"],
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=anime%20adventure%20poster%2C%20flying%20airship%20sailing%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20vivid%20orange%20and%20sky%20blue%2C%20yonkoma%20cel%20shaded%20style%2C%20grand%20adventurous%20composition&width=600&height=900&seq=miyue-tv-poster-17&orientation=portrait",
    synopsis:
      "在由浮空岛组成的世界里，少年骑士与他的飞行伙伴，为守护渐渐坠落的故乡，踏上了寻找传说中云之彼端的旅程。",
    tags: ["冒险", "热血", "治愈"],
  },
  {
    id: "anime-paper-stars",
    title: "纸星星",
    type: "anime",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "治愈", "校园"],
    director: "白墨",
    cast: ["苏小满", "风无痕"],
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20school%20anime%20poster%2C%20girl%20folding%20paper%20stars%20by%20a%20classroom%20window%20at%20golden%20hour%2C%20soft%20cream%20and%20amber%20palette%2C%20gentle%20youthful%20mood%2C%20hand%20drawn%20illustration&width=600&height=900&seq=miyue-tv-poster-18&orientation=portrait",
    synopsis:
      "转学生把愿望折进每一颗纸星星。当最后一个瓶子装满，她终于鼓起勇气，向一直默默陪伴的少年说出心里的话。",
    tags: ["青春", "治愈", "新番"],
  },
];